/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Site_AInputs */

const en_wc_faq_site_a = /** @type {(inputs: Wc_Faq_Site_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try WordCraft directly in the editor on this homepage, download a desktop build, follow beginner tutorials, and compare it with Microsoft Word. You can use the editor and read the guides without creating a site account.`)
};

/**
* | output |
* | --- |
* | "Try WordCraft directly in the editor on this homepage, download a desktop build, follow beginner tutorials, and compare it with Microsoft Word. You can use t..." |
*
* @param {Wc_Faq_Site_AInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_site_a = /** @type {((inputs?: Wc_Faq_Site_AInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Site_AInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_site_a(inputs)
});
export { wc_faq_site_a as "wc.faq.site.a" }